import {InjectionToken} from '@angular/core'
import {FeatureFlagsEmbeddedService} from '@service/feature-flags/feature-flags.embedded.service'
import {FeatureFlagsService} from '@service/feature-flags/feature-flags.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `FeatureFlagsService`.
 *
 * @description
 * En modo embebido devuelve `FeatureFlagsEmbeddedService`, que recibe los
 * tratamientos desde la app host. En modo standalone devuelve
 * `FeatureFlagsService`, que evalúa los flags con Split.io (SDK) más los
 * valores por defecto del enum `FeatureFlags`.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `FeatureFlagsService`.
 */
export function providerFeatureFlagsServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new FeatureFlagsEmbeddedService() : new FeatureFlagsService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `FeatureFlagsService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerFeatureFlagsServiceFactory}. Los consumidores inyectan
 * directamente `FeatureFlagsService` por el alias declarado en
 * `providers.ts`.
 */
export const FeatureFlagsServiceToken = new InjectionToken<FeatureFlagsService>('FeatureFlagsService')
